import { gql } from '@apollo/client';

import {
  BUYER_CORE_FIELDS,
  BUYER_USER_CORE_FIELDS
} from 'src/components/Auth/queries';

export const UPDATE_CURRENT_BUYER_USER = gql`
  ${BUYER_USER_CORE_FIELDS}
  mutation UpdateCurrentBuyerUser(
    $firstName: String
    $lastName: String
    $password: String
    $passwordConfirmation: String
  ) {
    updateCurrentBuyerUser(
      firstName: $firstName
      lastName: $lastName
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      buyerUser {
        ...BuyerUserCoreFields
      }
      errors { path, message }
    }
  }
`;

export const UPDATE_CURRENT_BUYER = gql`
  ${BUYER_CORE_FIELDS}
  mutation UpdateCurrentBuyer(
    $name: String!
    $companyName: String
    $street: String!
    $city: String!
    $state: String!
    $postalCode: String!
    $phoneNumber: String!
  ) {
    updateCurrentBuyer(
      name: $name
      companyName: $companyName
      street: $street
      city: $city
      state: $state
      postalCode: $postalCode
      phoneNumber: $phoneNumber
    ) {
      buyer {
        ...BuyerCoreFields
      }
      errors { path, message }
    }
  }
`;

export const UPDATE_DEFAULT_TITLE_RELEASE = gql`
  mutation UpdateDefaultTitleRelease(
    $titleOwnerName: String
    $titleShippingAddress1: String
    $titleShippingAddress2: String
    $titleCity: String
    $titleState: String
    $titleZip: String
    $titleShipOwnerName: String!
    $titleShipShippingAddress1: String!
    $titleShipShippingAddress2: String
    $titleShipCity: String!
    $titleShipState: String!
    $titleShipZip: String!
    $defaultTitleReleaseSignature: String
  ) {
    updateDefaultTitleRelease(
      titleOwnerName: $titleOwnerName
      titleShippingAddress1: $titleShippingAddress1
      titleShippingAddress2: $titleShippingAddress2
      titleCity: $titleCity
      titleState: $titleState
      titleZip: $titleZip
      titleShipOwnerName: $titleShipOwnerName
      titleShipShippingAddress1: $titleShipShippingAddress1
      titleShipShippingAddress2: $titleShipShippingAddress2
      titleShipCity: $titleShipCity
      titleShipState: $titleShipState
      titleShipZip: $titleShipZip
      defaultTitleReleaseSignature: $defaultTitleReleaseSignature
    ) {
      buyer {
        id
        titleOwnerName
        titleShippingAddress1
        titleShippingAddress2
        titleCity
        titleState
        titleZip
        titleShipOwnerName
        titleShipShippingAddress1
        titleShipShippingAddress2
        titleShipCity
        titleShipState
        titleShipZip
        defaultTitleReleaseSignature
        defaultTitleReleaseAt
      }
      errors {
        path
        message
      }
    }
  }
`;